module.exports = __webpack_public_path__ + "img/other-icon-img5.410c0b0f.svg";